import { gql } from 'apollo-boost';

export const MUTATE_ARTICLE_BY_TUTOR = gql`
	mutation MUTATE_ARTICLE_BY_TUTOR($title: String!, $image: String!, $content: String!, $tags: String) {
		addTutorArticle(title: $title, image: $image, content: $content, tags: $tags) {
			pvid
			title
			userPvid
			image
			content
			readTimeBySeconds
			tags {
				pvid
				name
			}
			avatar {
				token
				name
				FirstName
				LastName
				RelativePath
				AwsPath
			}
		}
	}
`;
export const GET_ARTICLE_BY_ID = gql`
	query GET_ARTICLE_BY_ID($pvid: Int!, $userPvid: Int) {
		getArticle(pvid: $pvid, userPvid: $userPvid) {
			pvid
			userPvid
			title
			image
			status
			created_at
			content
			comments
			views
			upvotes
			downvotes
			readTimeBySeconds
			vote
			tags {
				pvid
				name
			}
			avatar {
				token
				name
				FirstName
				LastName
				RelativePath
				AwsPath
			}
		}
	}
`;

export const mutateUploadArticleFeaturedImage = gql`
	mutation mutateUploadArticleFeaturedImage($file: Upload!) {
		uploadAvatar(tokenfile: $file) {
			fileName
		}
	}
`;
// path
export const GET_TUTOR_ARTICAL_DATA = gql`
	query GET_TUTOR_ARTICAL_DATA {
		getTutorArticles {
			pvid
			userPvid
			title
			image
			status
			created_at
			content
			comments
			views
			upvotes
			downvotes
			readTimeBySeconds
			tags {
				pvid
				name
			}
			avatar {
				token
				name
				FirstName
				LastName
				RelativePath
				AwsPath
			}
		}
	}
`;
export const GET_FEATURED_ARTICLE = gql`
	query featuredPost {
		featuredPost {
			pvid
			userPvid
			title
			status
			created_at
			image
			comments
			views
			upvotes
			downvotes
			content
			tags {
				pvid
				name
			}
			avatar {
				token
				name
				FirstName
				LastName
				RelativePath
				AwsPath
			}
		}
	}
`;
export const GET_POPULAR_POST = gql`
	query popularPost {
		popularPost {
			pvid
			userPvid
			title
			image
			status
			created_at
			comments
			views
			upvotes
			downvotes
			content
			readTimeBySeconds
			tags {
				pvid
				name
			}
			avatar {
				token
				name
				FirstName
				LastName
				RelativePath
				AwsPath
			}
		}
	}
`;
export const GET_NEWEST_POST = gql`
	query newestPost {
		newestPost {
			pvid
			userPvid
			status
			created_at
			title
			image
			comments
			views
			upvotes
			downvotes
			readTimeBySeconds
			content
			tags {
				pvid
				name
			}
			avatar {
				token
				name
				FirstName
				LastName
				RelativePath
				AwsPath
			}
		}
	}
`;

export const MUTATE_delete = gql`
	mutation MUTATE_delete($pvid: Int!) {
		deleteTutorArticle(pvid: $pvid) {
			text
			success
		}
	}
`;

export const MUTATE_EDIT = gql`
	mutation MUTATE_edit($pvid: Int!, $title: String!, $image: String!, $content: String!, $tags: [String]!) {
		editTutorArticle(pvid: $pvid, title: $title, image: $image, content: $content, tags: $tags) {
			text
			success
		}
	}
`;

export const mutate_editStatus = gql`
	mutation mutate_editStatus($pvid: Int!, $status: Int!) {
		editStatusTutorArticle(pvid: $pvid, status: $status) {
			text
			success
		}
	}
`;

export const ADD_COMMENT = gql`
	mutation ADD_COMMENT($comment: String!, $postId: Int!) {
		addComment(comment: $comment, postId: $postId) {
			text
			success
		}
	}
`;
export const GET_COMMENT = gql`
	mutation GET_COMMENT($postId: Int!) {
		getComment(postId: $postId) {
			pvid
			comment
			userPvid
			createdAt
			avatar {
				token
				FirstName
				name
				LastName
				RelativePath
				AwsPath
			}
		}
	}
`;
export const DELETE_COMMENT = gql`
	mutation DELETE_COMMENT($pvid: Int!, $postId: Int!) {
		deleteComment(pvid: $pvid, postId: $postId) {
			text
			success
		}
	}
`;
export const EDIT_COMMENT = gql`
	mutation EDIT_COMMENT($comment: String!, $pvid: Int!) {
		editComment(comment: $comment, pvid: $pvid) {
			text
			success
		}
	}
`;
export const VOTE = gql`
	mutation VOTE($postId: Int!, $status: Int!) {
		vote(postId: $postId, status: $status) {
			text
			success
		}
	}
`;

export const ADD_VIEW = gql`
	mutation ADD_VIEW($status: Int!, $postId: Int!) {
		viewCountInsert(status: $status, postId: $postId) {
			text
			success
		}
	}
`;

export const UPLOAD_ARTICLE_IMAGE = gql`
	mutation UPLOAD_ARTICLE_IMAGE($file: Upload!) {
		uploadStaticWebResource(file: $file) {
			pvid
			path
			fileName
			mimeType
			resourceTypePvid
			encoding
		}
	}
`;

export const GET_ALL_ARTICLES = gql`
	query GET_ALL_ARTICLES($sort: String, $page: Int, $limit: Int, $querySearch: ArticleSearch, $fromWhere: String) {
		getArticles(sort: $sort, page: $page, limit: $limit, querySearch: $querySearch, fromWhere: $fromWhere) {
			total
			count
			pagination {
				next {
					page
					limit
				}
				prev {
					page
					limit
				}
			}
			data {
				pvid
				userPvid
				title
				image
				content
				status
				vote
				views
				upvotes
				downvotes
				comments
				created_at
				tags {
					pvid
					name
				}
				avatar {
					name
					token
					FirstName
					LastName
					RelativePath
					AwsPath
				}
				readTimeBySeconds
			}
		}
	}
`;

export const GET_BOOSTED_ARTICLES = gql`
	mutation getBoostedArticlesOnHomePage {
		getBoostedArticlesOnHomePage {
			pvid
			userPvid
			title
			image
			content
			avatar {
				name
				FirstName
				LastName
				RelativePath
			}
		}
	}
`;
